<template>
  <el-table-column
    prop="responsible_user"
    sortable="custom"
    label="Felelős"
    show-overflow-tooltip
    width="200px"
  >
    <template slot-scope="scope">
      {{ scope.row.responsible_user.last_name }} {{ scope.row.responsible_user.first_name }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'responsible_user',
  };
</script>
